<template>
    <b-modal
        :visible="visible"
        centered
        hide-footer
        size="xl"
        title="Thêm đề thi"
        @hide="onClose"
    >
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Mã đề <span class="text-danger">*</span></label>
                            <ValidationProvider
                                v-slot="{ errors }"
                                name="Mã đề"
                                rules="required|max:100"
                            >
                                <input
                                    v-model="form.code"
                                    class="form-control"
                                    placeholder="Nhập mã đề"
                                    type="text"
                                />
                                <span class="text-danger small">{{ errors[0] || getApiError('code') }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Tên đề <span class="text-danger">*</span></label>
                            <ValidationProvider
                                v-slot="{ errors }"
                                name="Tên đề"
                                rules="required|max:100"
                            >
                                <input
                                    v-model="form.name"
                                    class="form-control"
                                    placeholder="Nhập tên đề"
                                    type="text"
                                />
                                <span class="text-danger small">{{ errors[0] || getApiError('name') }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Loại thi <span class="text-danger">*</span></label>
                            <ValidationProvider
                                v-slot="{ errors }"
                                name="Loại thi"
                                rules="required"
                            >
                                <select v-model="form.exam_type" class="form-control" @change="onExamTypeChange">
                                    <option value="">Chọn loại thi</option>
                                    <option
                                        v-for="type in examTypes"
                                        :key="type.value"
                                        :value="type.value"
                                    >
                                        {{ type.label }}
                                    </option>
                                </select>
                                <span class="text-danger small">{{ errors[0] || getApiError('exam_type') }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Trung tâm <span class="text-danger">*</span></label>
                            <ValidationProvider
                                v-slot="{ errors }"
                                name="Trung tâm"
                                rules="required"
                            >
                                <el-select
                                    v-model="form.center_ids"
                                    class="w-100"
                                    collapse-tags
                                    multiple
                                    placeholder="Chọn trung tâm"
                                    @change="onCenterChange"
                                >
                                    <el-option
                                        v-for="item in centers"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                                <span class="text-danger small">{{ errors[0] || getApiError('center_ids') }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div v-if="form.center_ids.length > 0 && !isEntranceExam" class="col-md-6">
                        <div class="form-group">
                            <label>Khoá học <span class="text-danger">*</span></label>
                            <ValidationProvider
                                v-slot="{ errors }"
                                name="Khoá học"
                                rules="required"
                            >
                                <el-select
                                    v-model="form.course_ids"
                                    class="w-100"
                                    collapse-tags
                                    multiple
                                    placeholder="Chọn khoá học"
                                >
                                    <el-option
                                        v-for="item in courses"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                                <span class="text-danger small">{{ errors[0] || getApiError('course_ids') }}</span>
                            </ValidationProvider>
                        </div>
                    </div>                   
                    <div class="col-md-6">
                        <div class="form-group">
                            <label
                            >Thời gian bắt đầu áp dụng
                                <span class="text-danger">*</span></label
                            >
                            <ValidationProvider
                                v-slot="{ errors }"
                                name="Thời gian bắt đầu áp dụng"
                                rules="required"
                            >
                                <date-picker
                                    v-model="form.apply_from"
                                    class="w-100"
                                    format="YYYY-MM-DD HH:mm:ss"
                                    placeholder="Chọn thời gian"
                                    type="datetime"
                                    value-type="format"
                                />
                                <span class="text-danger small">{{ errors[0] || getApiError('apply_from') }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Hình thức test <span class="text-danger">*</span></label>
                      <ValidationProvider
                          v-slot="{ errors }"
                          name="Hình thức test"
                          rules="required"
                      >
                        <el-select
                            v-model="form.exam_mode"
                            class="w-100"
                            collapse-tags
                            placeholder="Chọn hình thức test"
                            :disabled="isEntranceExam"
                        >
                          <el-option
                              v-for="item in examModes"
                              :key="item.value"
                              :label="item.name"
                              :value="item.value"
                          >
                          </el-option>
                        </el-select>
                        <span class="text-danger small">{{ errors[0] || getApiError('exam_mode') }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div v-if="isEntranceExam" class="col-md-6">
                    <div class="form-group">
                      <label>Thứ tự mã đề <span class="text-danger">*</span></label>
                      <ValidationProvider
                          v-slot="{ errors }"
                          name="Thứ tự mã đề"
                          rules="required"
                      >
                        <el-select
                            v-model="form.order"
                            class="w-100"
                            placeholder="Chọn thứ tự mã đề"
                        >
                          <el-option
                              v-for="item in orderOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                          >
                          </el-option>
                        </el-select>
                        <span class="text-danger small">{{ errors[0] || getApiError('order') }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-end mt-4">
                    <button class="btn btn-light mr-2" type="button" @click="onClose">
                        Huỷ bỏ
                    </button>
                    <button
                        :disabled="isSubmitting"
                        class="btn btn-primary"
                        type="submit"
                    >
            <span
                v-if="isSubmitting"
                class="spinner-border spinner-border-sm mr-1"
            ></span>
                        Xác nhận
                    </button>
                </div>
            </form>
        </ValidationObserver>
    </b-modal>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

const EXAM_TYPE_ENTRANCE_EXAM = 20;
const EXAM_MODE_ONLINE = 2;

export default {
    name: "MarkingExamCreateModal",
    components: {ValidationObserver, ValidationProvider, DatePicker},
    props: {
        visible: Boolean,
        centers: Array,
        courses: Array,
        examTypes: Array,
        selectedCenterIds: Array,
        orderOptions: Array,
    },
    data() {
        return {
            form: {
                code: "",
                name: "",
                center_ids: [],
                course_ids: [],
                exam_type: "",
                order: "",
                apply_from: "",
                exam_mode: null
            },
            apiErrors: {},
            isSubmitting: false,
            examModes: [{ name: 'Online' , value: 2},{ name: 'Offline' , value: 1}]
        };
    },
    computed: {
        isEntranceExam() {
            return Number(this.form.exam_type) === EXAM_TYPE_ENTRANCE_EXAM;
        },
    },
    watch: {
        selectedCenterIds(val) {
            this.form.center_ids = val;
        },
        visible(val) {
            if (val) {
                this.form = {
                    code: "",
                    name: "",
                    center_ids: [],
                    course_ids: [],
                    exam_type: "",
                    order: "",
                    apply_from: "",
                    exam_mode: null,
                };
            }
            this.isSubmitting = false;
        },
    },
    methods: {
        getApiError(field) {
            return this.apiErrors?.[field]?.[0] || '';
        },
        onClose() {
            this.$emit('close');
            this.form = {
                code: "",
                name: "",
                center_ids: [],
                course_ids: [],
                exam_type: "",
                order: "",
                apply_from: "",
                exam_mode: null,
            };
            this.apiErrors = {};
        },
        onExamTypeChange() {
            if (this.isEntranceExam) {
                this.form.exam_mode = EXAM_MODE_ONLINE;
                this.form.course_ids = [];
            } else {
                this.form.order = "";
            }
        },
        async onSubmit() {
            this.isSubmitting = true;
            this.apiErrors = {};
            try {
                const payload = {
                    ...this.form,
                    course_ids: this.isEntranceExam ? [] : this.form.course_ids,
                };
                if (this.isEntranceExam) {
                    payload.exam_mode = EXAM_MODE_ONLINE;
                } else {
                    delete payload.order;
                }
                const res = await this.$store.dispatch('CREATE_MARKING_EXAM', payload);
                if (!res.error) {
                    this.$emit('created');
                    this.onClose();
                }
            } catch (e) {
                let errors = {};
                if (e.response?.data?.errors) {
                    errors = e.response.data.errors;
                } else if (e?.data?.data?.message_validate_form) {
                    errors = e.data.data.message_validate_form;
                }

                this.apiErrors = errors;
                if (this.$refs.observer && typeof this.$refs.observer.setErrors === 'function') {
                    this.$refs.observer.setErrors(errors);
                }
            } finally {
                this.isSubmitting = false;
            }
        },
        onCenterChange() {
            if (!this.isEntranceExam) {
                this.form.course_ids = [];
            }
            this.$emit("center-change", this.form.center_ids);
        },
    },
};
</script>
